<div class="calendar-container" [class.calendar-container--loading]="loading()">
  <full-calendar [options]="mergedOptions()" [events]="events() ?? []"></full-calendar>

  @if (loading()) {
    <div class="calendar-overlay">
      <p-progressSpinner i18n-ariaLabel ariaLabel="Caricamento" [style]="{ width: '3rem', height: '3rem' }" />
    </div>
  }
</div>

<p-popover
  #eventPopover
  appendTo="body"
  styleClass="calendar-event-popover"
  [focusOnShow]="false"
  [baseZIndex]="previewBaseZIndex"
  (onShow)="onPreviewShown()">
  @if (preview(); as event) {
    <div
      class="calendar-event-preview"
      (mouseenter)="onPreviewEnter()"
      (mouseleave)="onPreviewLeave()">
      <div class="calendar-event-preview__header">
        <div class="calendar-event-preview__title-row">
          <span class="calendar-event-preview__dot" [style.background-color]="event.dotColor"></span>
          <span class="calendar-event-preview__title" [attr.title]="event.title">{{ event.title }}</span>
        </div>
        <p-button
          styleClass="calendar-event-preview__close"
          icon="pi pi-times"
          severity="secondary"
          [text]="true"
          size="small"
          i18n-ariaLabel
          ariaLabel="Chiudi"
          (onClick)="hidePreview()" />
      </div>
      <div class="calendar-event-preview__divider"></div>
      <div class="calendar-event-preview__body">
        <div class="calendar-event-preview__row">
          <div class="calendar-event-preview__label">
            <i class="pi pi-user" aria-hidden="true"></i>
            <span i18n>Paziente:</span>
          </div>
          <span class="calendar-event-preview__value">{{ event.patientName || '—' }}</span>
        </div>
        <div class="calendar-event-preview__row">
          <div class="calendar-event-preview__label">
            <i class="pi pi-clock" aria-hidden="true"></i>
            <span i18n>Orario:</span>
          </div>
          <span class="calendar-event-preview__value">
            @if (event.allDay) {
              <ng-container i18n>Tutto il giorno</ng-container>
            } @else if (event.start && event.end) {
              {{ event.start | date: 'HH:mm' }} – {{ event.end | date: 'HH:mm' }}
            } @else {
              —
            }
          </span>
        </div>
        <div class="calendar-event-preview__row">
          <div class="calendar-event-preview__label">
            <i class="pi pi-hourglass" aria-hidden="true"></i>
            <span i18n>Durata:</span>
          </div>
          <span class="calendar-event-preview__value">
            @if (event.durationSeconds !== null) {
              {{ event.durationSeconds | duration }}
            } @else {
              —
            }
          </span>
        </div>
        <div class="calendar-event-preview__row">
          <div class="calendar-event-preview__label">
            <i class="pi pi-flag" aria-hidden="true"></i>
            <span i18n>Stato:</span>
          </div>
          <span class="calendar-event-preview__value">
            <app-event-status-tag [value]="event.status" />
          </span>
        </div>
        <div class="calendar-event-preview__row">
          <div class="calendar-event-preview__label">
            <i class="pi pi-tags" aria-hidden="true"></i>
            <span i18n>Tipo:</span>
          </div>
          <span class="calendar-event-preview__value">{{ typeLabel(event.type) }}</span>
        </div>
      </div>
    </div>
  }
</p-popover>
